import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  login: ['username', 'password'],
  loginLoading: null,
  loginSuccess: ['res'],
  loginFailure: ['error'],

  loginAuth: ['sessionToken'],
  loginAuthLoading: null,
  loginAuthSuccess: ['res'],
  loginAuthFailure: ['error'],

  loginHeroku: ['id_token'],
  loginHerokuLoading: null,
  loginHerokuSuccess: ['res'],
  loginHerokuFailure: ['error'],

  loginTokenExchange: ['code'],
  loginTokenExchangeLoading: null,
  loginTokenExchangeSuccess: ['res'],
  loginTokenExchangeFailure: ['error'],

  register: ['donor'],
  registerLoading: null,
  registerSuccess: ['res'],
  registerFailure: ['error'],

  saveSignUp: ['user'],
  saveCreateProfile: ['profile'],

  logout: ['authToken'],
  logoutLoading: null,
  logoutSuccess: ['res'],
  logoutFailure: ['error'],

  getSession: null,
  getSessionLoading: null,
  getSessionSuccess: ['res'],
  getSessionFailure: ['error'],

  getSessionUser: null,
  getSessionUserLoading: null,
  getSessionUserSuccess: ['res'],
  getSessionUserFailure: ['error'],

  //

  changePassword: ['oldPassword', 'newPassword'],
  changePasswordLoading: null,
  changePasswordSuccess: ['res'],
  changePasswordFailure: ['error'],

  changeRecoveryQuestion: ['currentPassword', 'recoveryQuestion', 'recoveryAnswer'],
  changeRecoveryQuestionLoading: null,
  changeRecoveryQuestionSuccess: ['res'],
  changeRecoveryQuestionFailure: ['error'],

  forgotPassword: ['sendEmail'],
  forgotPasswordLoading: null,
  forgotPasswordSuccess: ['res'],
  forgotPasswordFailure: ['error'],

  sessionRefresh: null,
  sessionRefreshLoading: null,
  sessionRefreshSuccess: ['res'],
  sessionRefreshFailure: ['error']

}, { prefix: 'AUTH_CUSTOM_' })

export const AuthCustomTypes = Types

export default Creators
